
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    SPEEDCHECK_ACTION,
    ALL_SPEEDCHECK,
    ADD_SPEEDCHECK,
    FETCH_SPEEDCHECK,
    EDIT_SPEEDCHECK,
    DELETE_SPEEDCHECK
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * SPEED CHECK Actions
 */

    export const allSpeedCheck = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: SPEEDCHECK_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqspeedcheck', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata = response.data.data || [];
                dispatch({ type: ALL_SPEEDCHECK, payload: alldata });
            });
        }        
    
    }

    export const studentSpeedCheck = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:SPEEDCHECK_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getstudenttqspeedcheck', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata = response.data.data || [];
                dispatch({ type: ALL_SPEEDCHECK, payload: alldata }); 
            });
        
        }
    }

    export const addSpeedCheck = (data) =>{
        var id=data.target.student.value;
        var payload={
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
        }

        for (let j = 1; j<=5; j++) {                    

            var clbsp='clubspeed_'+j; 
            var speedval=data.target[clbsp].value;
            var balsp='ballspeed_'+j; 
            var ballval=data.target[balsp].value;
            var cary='carry_'+j; 
            var caryval=data.target[cary].value;                        
            
            payload[clbsp]=speedval;
            payload[balsp]=ballval;
            payload[cary]=caryval;

        }
        return (dispatch) => { 
            dispatch({ type:SPEEDCHECK_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtqspeedcheck', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allSpeedCheck()(dispatch);
                    studentSpeedCheck(id, '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_SPEEDCHECK});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchSpeedCheck = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:SPEEDCHECK_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtqspeedcheck', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_SPEEDCHECK, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editSpeedCheck = (data, id) =>{
        var stdid=data.target.student.value;
        var payload={
            "id":id,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
        }

        for (let j = 1; j<=5; j++) {                    

            var clbsp='clubspeed_'+j; 
            var speedval=data.target[clbsp].value;
            var balsp='ballspeed_'+j; 
            var ballval=data.target[balsp].value;
            var cary='carry_'+j; 
            var caryval=data.target[cary].value;                        
            
            payload[clbsp]=speedval;
            payload[balsp]=ballval;
            payload[cary]=caryval;

        }
        return (dispatch) => { 
            dispatch({ type:SPEEDCHECK_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittqspeedcheck', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allSpeedCheck()(dispatch);
                    studentSpeedCheck(stdid, '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_SPEEDCHECK});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteSpeedCheck = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:SPEEDCHECK_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqspeedcheck', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allSpeedCheck()(dispatch);
                    studentSpeedCheck(id, '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_SPEEDCHECK});                    
                }                
                
            });
        
        }
    }


   

